export default {
    //Custom
    ACCESS_TOKEN: "@access_token",
    PERMISSIONS: "@permissions",
    REFRESH_TOKEN: "@refresh_token",
    EXPO_DEVICE_ID: "@expo_device_id",
    IS_LOGGED_IN: "@is_logged_in",
    USER_DETAILS_JSON: "@user_details_json",
    AGENT_DETAILS_JSON: "@agent_details_json",
    OWNER_DETAILS_JSON: "@owner_details_json",
    FULL_LOGIN_DETAILS_JSON: "@full_login_details_json",
    USERNAME: "@username",
    FULL_NAME: "@full_name",
    EMAIL: "@email",
    COUNTRY: "@country",
    LANGUAGE: "@language",
    IS_SUPER_ADMIN: "@is_super_admin",
    USER_SETTINGS: "@user_settings",
    LOGIN_TIME: "@login_time",
    CURRENCIES: "@CURRENCIES",
 };
 